import React, { FC, useCallback, useMemo } from 'react'
import { Grid, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from '../../../../components/Modal'
import { approveCommissionsModal } from '../../../../store/selectors'
import { GreenButton } from '../../../../components/Buttons/GreenButton'
import { approveCommissionsRequest } from '../../../../store/actions'

interface CommissionsApproveModalProps {
  isOpen: boolean
  modalClose: () => void
  clearCheckedIds: () => void
  handleAdjust: () => void
}

export const CommissionsApproveModal: FC<CommissionsApproveModalProps> = ({
  isOpen,
  modalClose,
  clearCheckedIds,
  handleAdjust,
}) => {
  const dispatch = useDispatch()
  const { ids } = useSelector(approveCommissionsModal)

  const onSubmit = useCallback(() => {
    dispatch(approveCommissionsRequest({ commissions: ids }))
    clearCheckedIds()
  }, [dispatch, clearCheckedIds, ids])

  const isMany = useMemo(() => ids.length > 1, [ids])

  return (
    <Modal
      title={`Approve ${isMany ? 'selected' : ''} commission${isMany ? 's' : ''}`}
      submitTitle="Approve"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={onSubmit}
    >
      <Grid container display={'flex'} justifyContent={'space-between'} minHeight={80}>
        <Grid item xs={8}>
          <Typography variant="body1" component="div">
            {`Are you sure you want to approve ${isMany ? 'all selected' : 'this'} commission${isMany ? 's' : ''}?`}
          </Typography>
        </Grid>
        <Grid item xs={4} display={'flex'} justifyContent={'flex-end'}>
          <GreenButton width={100} text={'Adjust'} backgroundColor="#E08E2C" onClick={handleAdjust} />
        </Grid>
      </Grid>
    </Modal>
  )
}
